import styled from "styled-components";
import { Breakpoints } from "styles/breakpoints";
import colours from "styles/colours";

export const StyledList = styled.li`
  letter-spacing: 0.15em;

  &.navbar-item {
    /* Override Bulma's white-space: nowrap for navbar-dropdown items to allow text wrapping */
    white-space: normal;
  }

  a {
    color: ${colours.elexonBlack};

    &:hover {
      text-decoration: underline;
    }

    @media (max-width: ${Breakpoints.Small}) {
      color: ${colours.white};
      padding-left: 1rem;
      display: block;
      padding-top: 0.5rem;
      padding-bottom: 0.5rem;
    }
  }
`;

export const StyledExternalNavLink = styled.a`
  color: ${colours.elexonBlack};
  &&&:hover {
    text-decoration: underline;
    box-shadow: none;
    background-color: ${colours.white};
  }
`;
